/**
 * Les options de capture du partage d'écran sur le web, la seule source : le bouton de la barre de
 * l'ancien live (`ControlBarM.web`, tuteur compris), son menu des trois points
 * (`common/hooks/livekit/useScreenShare.web.js`) et le live du design system
 * (`useScreenShareToggle.web.ts`) capturent de la même façon — le son de l'onglet, et l'onglet
 * lui-même proposable. Déplacées de `common/livekit/constants.ts`, à l'identique.
 */
export const SCREEN_SHARE_CAPTURE_OPTIONS = {
    audio: true,
    selfBrowserSurface: "include",
} as const

/** Le partage d'écran de la salle, tel qu'un écran le pose sur son bouton. */
export type ScreenShareToggle = {
    /** L'écran est partagé. */
    on: boolean
    /** Le navigateur demande quoi partager, ou la piste part : le bouton attend. */
    pending: boolean
    onToggle: () => void
}

/**
 * Le bouton du partage paraît-il, et sinon pourquoi : le navigateur ne sait pas partager
 * (`unsupported`), ou la salle n'a pas (encore) donné le droit de publier (`no_publish`, avant la
 * connexion ou après une reprise). La même règle que l'ancienne barre (`ControlBarM.web`).
 */
export function screenShareGate(args: {
    supported: boolean
    canPublish: boolean | undefined
}): "shown" | "unsupported" | "no_publish" {
    if (!args.supported) return "unsupported"
    return args.canPublish === true ? "shown" : "no_publish"
}
